// Platform detection helpers for the command palette. Determines whether
// the user is on a Mac (⌘K) or non-Mac (Ctrl K) so the UI shows the
// correct shortcut label.

/** Returns true when the current platform is macOS. Safe to call at
 *  module level — uses userAgentData when available, falls back to the
 *  legacy navigator.platform string. */
export function isMacPlatform(): boolean {
  if (typeof navigator === "undefined") return false;
  const platformData = (
    navigator as Navigator & {
      userAgentData?: { platform: string };
    }
  ).userAgentData?.platform;
  if (platformData) return /mac/iu.test(platformData);
  return /mac/iu.test(navigator.platform);
}

/** Returns the locale-appropriate shortcut label: "⌘K" on Mac, "Ctrl K"
 *  elsewhere. */
export function shortcutLabel(): string {
  return isMacPlatform() ? "⌘K" : "Ctrl K";
}
